import React from 'react'
import LoanCalculator from './LoanCalculator'

const EMICalculator = () => {
  return (
    <div>
      <section className="welcome_area emi" id="home">
        <div className="container">
          <div className="row align-items-center">
             
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge"> EMI Calculator</p>
                    </div>
                    <span className="integration-text">
                      Calculate your monthly loan payments instantly
                    </span>
                  </div>
                </div>

                <h1 className="b-text bold">
                  Plan Your Loan Smartly with Finbasket EMI Calculator
                </h1>

                <p>
                  Use the Finbasket EMI Calculator to estimate your monthly
                  installments quickly and accurately.
                </p>

                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="/contact-us" className="btn more-btn mr-3">
                    Contact Us
                  </a>
                  <a className="btn more-btn" href="/apply-for-loan">
                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>

      <LoanCalculator />
    </div>
  )
}

export default EMICalculator
